import css from "styled-jsx/css";
import colors from "styles/colors";
import { BLACK_COLOR_NAME, MARKETING_RED_COLOR_NAME } from "styles/color-consts";
import { LAYER_ONE } from "constants/z-index";
import { getComponentShadowFilter } from "segments/desktop/constants";

const CARD_BORDER_RADIUS = 8;

export const componentStyles = css`
  .product-card {
    width: 286px;
    z-index: ${LAYER_ONE};
    margin: 32px 10px 0;
    padding: 32px 24px;
    border-radius: ${`${CARD_BORDER_RADIUS}px`};
    background-color: white;
    filter: ${getComponentShadowFilter(0.16)};
    transition: filter 0.2s ease-in-out;
    color: ${colors[BLACK_COLOR_NAME]};
    position: relative;

    &:hover,
    &.highlighted {
      filter: ${getComponentShadowFilter(0.32)};
    }

    // remove hover effect in safari because of this bug: https://monday.monday.com/boards/757661511/pulses/2181485781
    @media not all and (min-resolution: 0.001dpcm) {
      @supports (-webkit-appearance: none) {
        &:hover,
        &.highlighted {
          filter: ${getComponentShadowFilter(0.16)};
        }
      }
    }

    &.highlighted::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: ${`${CARD_BORDER_RADIUS}px`};
      padding: 2px;
      background: var(--color);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#000 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }

    &.is-at-least-one-card-highlighted {
      margin: 44px 10px 12px;
      padding: 32px 24px;
      &.highlighted {
        margin: 32px 2px 0;
        padding: 44px 24px;
      }
    }
    .product-card-header {
      margin-bottom: 32px;

      .product-card-header-image {
        height: 51px;
        margin-bottom: 5px;

        :global(img) {
          max-height: 51px;
        }
      }

      .product-card-header-subtitle {
        color: ${colors.asphalt};
        font-size: 14px;
      }
    }

    .product-card-body {
      font-weight: lighter;
      line-height: 1.5;
    }

    .product-card-divider {
      box-sizing: content-box;
      border-width: 1px;
      border-style: solid;
      border-image: linear-gradient(to right, #ff158aff, #ff158a00);
      border-image-slice: 1;
      margin-bottom: 20px;
      margin-top: 32px;
    }

    .product-card-use-cases {
      .product-card-use-cases-title {
        margin-bottom: 12px;
        font-size: 14px;
      }

      .product-card-use-cases-bullets {
        display: flex;
        margin-bottom: 20px;
        flex-direction: column;

        .product-card-use-cases-bullet-icon-and-text {
          display: flex;
          margin-bottom: 5px;
          font-size: 14px;

          .product-card-use-cases-bullet-icon {
            color: ${colors[MARKETING_RED_COLOR_NAME]};
            margin-right: 5px;
          }
        }
      }
    }

    @mixin card-button {
      font-size: 14px;
      white-space: nowrap;
      min-width: unset;

      :global(*) {
        font-weight: 400;
      }
    }

    .product-card-footer {
      :global(.signup-combo-buttons-button .signup-button.ladda-button) {
        @include card-button;
      }

      :global(.signup-form-core-component-wrapper .signup-form) {
        justify-content: flex-start;

        :global(.signup-button) {
          @include card-button;
        }
      }

      :global(.secondary-button) {
        font-size: 14px;
        margin-left: 0;

        :global(*) {
          font-weight: 500;
        }
      }
    }
  }
`;
